<div class="modal-overlay" (click)="onOverlayClick()">
  <div class="modal-box" [class.narrow]="view() === 'prompt'" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div class="modal-header-info">
        <div class="modal-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6366F1" stroke-width="2"><path d="M9 2v6L3 20a2 2 0 0 0 2 3h14a2 2 0 0 0 2-3l-6-12V2"/><path d="M9 2h6"/><path d="M6.5 15h11"/></svg>
        </div>
        <div class="modal-title-col">
          <h2 class="modal-title">Test Guardrails</h2>
          <p class="modal-desc" *ngIf="view() === 'prompt'">Send a prompt and compare the response with and without your enabled guardrails applied.</p>
          <p class="modal-desc" *ngIf="view() === 'results'">Comparing responses for your test prompt.</p>
        </div>
      </div>
      <button class="close-btn" (click)="onClose()">✕</button>
    </div>

    <!-- Step 1: prompt input -->
    <div class="modal-body" *ngIf="view() === 'prompt'">
      <div class="active-row" *ngIf="enabledGuardrailNames().length; else noneEnabled">
        <span class="active-label">Testing against:</span>
        <span class="chip" *ngFor="let name of enabledGuardrailNames()">{{ name }}</span>
      </div>
      <ng-template #noneEnabled>
        <p class="none-enabled-hint">No guardrails are enabled — both responses will be identical. Enable at least one from the card grid to see a difference.</p>
      </ng-template>

      <label class="field-label" for="test-prompt">Prompt</label>
      <textarea
        id="test-prompt"
        class="prompt-field"
        rows="5"
        placeholder="e.g. Can you summarize this contract and include the client's email and SSN?"
        [ngModel]="prompt()"
        (ngModelChange)="prompt.set($event)"
      ></textarea>
    </div>

    <!-- Step 2: results -->
    <div class="modal-body" *ngIf="view() === 'results' && result() as r">
      <div class="tested-prompt-box">
        <span class="tested-prompt-label">Prompt</span>
        <p class="tested-prompt-text">{{ prompt() }}</p>
      </div>

      <div class="error-banner" *ngIf="r.error">
        <span class="error-title">Request failed</span>
        <p class="error-text">{{ r.withoutGuardrails }}</p>
      </div>

      <div class="results-row" *ngIf="!r.error">
        <div class="result-card">
          <div class="result-header">
            <span class="result-dot without"></span>
            <span class="result-title">Without Guardrails</span>
          </div>
          <div class="result-text" [innerHTML]="formatMarkdown(r.withoutGuardrails)"></div>
        </div>
        <div class="result-card">
          <div class="result-header">
            <span class="result-dot" [class.with]="!r.blocked" [class.blocked]="r.blocked"></span>
            <span class="result-title">With Guardrails</span>
            <span class="stage-badge" *ngIf="r.blocked && r.blockedStage">Blocked at {{ r.blockedStage }}</span>
          </div>
          <div class="no-guardrails-msg" *ngIf="r.notHit">No guardrails have been applied.</div>
          <div class="result-text" *ngIf="!r.notHit" [innerHTML]="formatMarkdown(r.withGuardrails)"></div>
          <div class="triggered-row" *ngIf="r.triggeredGuardrails.length">
            <span class="chip small" *ngFor="let name of r.triggeredGuardrails">{{ name }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <ng-container *ngIf="view() === 'prompt'">
        <app-button variant="secondary" size="sm" (clicked)="onClose()">Cancel</app-button>
        <app-button variant="primary" size="sm" [disabled]="!prompt().trim() || isRunning()" (clicked)="runTest()">
          {{ isRunning() ? 'Running…' : 'Run Test' }}
        </app-button>
      </ng-container>
      <ng-container *ngIf="view() === 'results'">
        <app-button variant="secondary" size="sm" (clicked)="editPrompt()">Edit Prompt</app-button>
        <app-button variant="primary" size="sm" (clicked)="onClose()">Done</app-button>
      </ng-container>
    </div>
  </div>
</div>
